/**
 * Triggers a CSV export download for the given entity.
 * Uses fetch with same-origin credentials (cookie auth).
 * Passes current filter params and visible columns to the export endpoint.
 */
export async function exportCsv(
  entity: string,
  filters: Record<string, string | undefined>,
  visibleColumns?: string[]
): Promise<void> {
  const params = new URLSearchParams()

  // Add filter params
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== "") {
      params.set(key, value)
    }
  })

  // Add visible columns
  if (visibleColumns && visibleColumns.length > 0) {
    params.set("columns", visibleColumns.join(","))
  }

  const queryString = params.toString()
  const url = `/api/v1/${entity}/export_csv${queryString ? `?${queryString}` : ""}`

  const response = await fetch(url, {
    method: "GET",
    credentials: "same-origin",
  })

  if (!response.ok) {
    throw new Error(`Export failed: ${response.status}`)
  }

  const blob = await response.blob()
  const contentDisposition = response.headers.get("Content-Disposition")
  let filename = `${entity}_export.csv`

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/)
    if (filenameMatch) {
      filename = filenameMatch[1]
    }
  }

  // Create a temporary download link
  const downloadUrl = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = downloadUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(downloadUrl)
}
